import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track13DRed = ({ state, workState, onLabelClick }) => (
	<g id="Track13DRed" transform="translate(1716.000000, 1156.000000)" className="track">
		<g id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			 strokeLinecap="round" strokeWidth={tracksWidth}
		>
			<path
				d="M42.1816178,140.702816 L44.0361953,140.012884 C49.5790937,137.950839 54.659396,134.812811 58.9846399,130.779448 C63.3075907,126.748223 66.7670817,121.88128 69.153485,116.473531 L83.4322551,84.1168823 C87.1266025,75.7452441 91.9525198,67.9202874 97.7749005,60.8610798 L147.972656,0 L147.972656,0"/>
			<line x1="-5.32907052e-15" y1="157" x2="30" y2="145.626921"/>

			<TrackArrow
				transform="translate(28.332331, 146.248121) rotate(-201.000000) translate(-28.332331, -146.248121) "
				points="32.3323312 154.248121 24.3323312 146.248121 32.3323312 138.248121"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track13DRed')}
			coords="49.972656, 99.000000"
			text="13D"
			textCoordsX="7.07714844"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track13DRed.propTypes = trackPropTypes;

export default Track13DRed;
